module.exports = __webpack_public_path__ + "img/Welcome-Efide-newgirl.3212cede.jpg";